import { AxiosError } from 'axios';
import {
  FormAccessRestrictionRedirectResponse,
  FormPageResponse,
} from 'backend';
import { valueOf } from 'shared';
import {
  ErrorContent,
  ErrorResponseBody,
  ERROR_RESPONSE_STATUS,
  MaintenanceErrorResponseBody,
} from '../../fetcher';
import { commonError } from './shared';

export const NEXT_ERROR_PAGE_TYPE = {
  error: 'error',
  maintenance: 'maintenance',
  receptionAuthenticationError: 'receptionAuthenticationError',
} as const;

type HandleErrorResultHasError = {
  type: valueOf<Pick<typeof NEXT_ERROR_PAGE_TYPE, 'error' | 'maintenance'>>;
  error: ErrorContent;
};

type HandleErrorResultHasPage = {
  type: typeof NEXT_ERROR_PAGE_TYPE.receptionAuthenticationError;
  data: FormPageResponse;
};

export const handleError = (
  e: unknown,
): HandleErrorResultHasError | HandleErrorResultHasPage => {
  const error = e as AxiosError<
    | ErrorResponseBody
    | MaintenanceErrorResponseBody
    | FormPageResponse
    | FormAccessRestrictionRedirectResponse
  >;

  if (error.response?.data == null || typeof error.response.data !== 'object') {
    return {
      type: NEXT_ERROR_PAGE_TYPE.error,
      error: commonError,
    };
  }

  const { status, data } = error.response;

  if (status === ERROR_RESPONSE_STATUS.forbidden && 'redirectUrl' in data) {
    window.location.assign(data.redirectUrl);
  }

  if (status === ERROR_RESPONSE_STATUS.unauthorized && 'page' in data) {
    return {
      type: NEXT_ERROR_PAGE_TYPE.receptionAuthenticationError,
      data,
    };
  }

  if (!('error' in data)) {
    return {
      type: NEXT_ERROR_PAGE_TYPE.error,
      error: commonError,
    };
  }

  if (status === ERROR_RESPONSE_STATUS.maintenance) {
    return {
      type: NEXT_ERROR_PAGE_TYPE.maintenance,
      error: (data as MaintenanceErrorResponseBody).error,
    };
  }
  return {
    type: NEXT_ERROR_PAGE_TYPE.error,
    error: (data as ErrorResponseBody).error,
  };
};
